// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ICommissionProfileForPage, useAddCommissionParameterCheckFiles, useAddCommissionParameterFiles, useAddCommissionProfile, useAuthorization, useUpdateCommissionProfile } from "../../../hooks";
import { Box, Card, CardContent, FormControl, Grid, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Stack } from "@mui/system";
import { Button, Loading } from "../../atoms";
import { InputControl } from "../../molecules";
import { useForm } from "react-hook-form";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import {
  bankAddProfileFormSchema,
  BankAddProfileFormSchemaFormValuesType,
} from "./_formTypes";
import { zodResolver } from "@hookform/resolvers/zod";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useEffect, useRef, useState } from "react";
import GetAppIcon from '@mui/icons-material/GetApp';
import ErrorIcon from '@mui/icons-material/Error';

export const BankAddBulkCommissionUploadForm = () => {
  const navigate = useNavigate();
  // const {showCreate} = useAuthorization();
  const theme = useTheme();
  // const commissionProfile = useLocation()
  // .state as unknown as ICommissionProfileForPage;
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  // const { control, reset, handleSubmit } =
  //   useForm<BankAddProfileFormSchemaFormValuesType>({
  //     resolver: zodResolver(bankAddProfileFormSchema),
  //   });
  const setSnackbar = useSetSnackBar();

  // const { mutate: commissionFilesUpload,isLoading } = useAddCommissionParameterFiles();



  const FileUpdload = ({ }) => {

    const [responseData, setResponseData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [hasCheckedFile, setHasCheckedFile] = useState(false);
    const [uploadCompleted, setUploadCompleted] = useState(false);
    const [uploadSuccessful, setUploadSuccessful] = useState(false)
    const { mutate: commissionFilesUpload } = useAddCommissionParameterFiles();
    const { mutate: commissionCheckFilesUpload } = useAddCommissionParameterCheckFiles();

    const checkFileExtension = (file) => {
      const acceptedExtension = 'xlsx';
      const currentExtension = file.name.split('.').pop();
      return currentExtension === acceptedExtension;
    };

    const fileInput = useRef();

    const handleFileChange = (e) => {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        if (checkFileExtension(selectedFile)) {
          setFile(selectedFile);
          setHasCheckedFile(false); // Yeni bir dosya seçildiğinde kontrolün tekrar yapılması için bu değeri sıfırlıyoruz.
          setUploadCompleted(false);
        } else {
          setFile(null);
          fileInput.current.value = '';
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "Lütfen .xlsx formatında dosya yükleyiniz",
          });
        }
      }

    };


    const handleCheckFile = async () => {
      if (!file) return;

      setLoading(true);

      const formData = new FormData();
      formData.append('files', file);

      commissionCheckFilesUpload(formData, {
        onSuccess: (data) => {
          setLoading(false);
          if (data.isSuccess) {
            setHasCheckedFile(true);
            setResponseData(data);
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: "Dosya kontrolü başarılı! Yüklemeye devam edebilirsiniz.",
            });
          } else {
            setHasCheckedFile(false);
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: data.message || "Dosya kontrolünde hata oluştu",
            });
          }
        },
        onError: (error) => {
          setLoading(false);
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "İşlem sırasında bir hata oluştu",
          });
        },
      });
    };

    const handleSubmit = async () => {

      if (!file || !hasCheckedFile) return;

      setLoading(true);

      const formData = new FormData();
      formData.append('files', file);

      commissionFilesUpload(formData, {
        onSuccess: (data) => {
          setLoading(false);
          setUploadCompleted(true);
          setHasCheckedFile(false);
          if (data.isSuccess) {
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: "Dosya Yükleme İşlemi Başarıyla Gerçekleşti",
            });
            setUploadSuccessful(true);
          } else {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: data.message || "Dosya yüklenirken bir hata oluştu",
            });
          }
        },
        onError: (error) => {
          setLoading(false);
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "İşlem sırasında bir hata oluştu",
          });
        },
      });
    }


    return (
      <>

        <Box sx={{ width: '100%' }}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                variant="outlined"
                fullWidth
                type="file"
                onChange={handleFileChange}
                InputLabelProps={{
                  shrink: true,
                }}
                inputRef={fileInput}
                sx={{ height: '56px' }}
              />
            </Grid>
            <Grid item xs={4}>
              <Button
                text={uploadCompleted && !hasCheckedFile ? "Yükle" : !hasCheckedFile ? "Yükle" : "Yüklemeyi Tamamla"}
                variant="contained"
                color="primary"
                disabled={!file || loading || (uploadCompleted && !hasCheckedFile)}
                onClick={!hasCheckedFile ? handleCheckFile : handleSubmit}
                fullWidth
                sx={{ height: '55px' }}
              >
                {uploadCompleted && !hasCheckedFile ? "Yükle" : !hasCheckedFile ? "Yükle" : "Yüklemeyi Tamamla"}
              </Button>


            </Grid>


          </Grid>
        </Box>
        {uploadCompleted && (
          uploadSuccessful ? (
            <Card sx={{ minWidth: '100%', minHeight: 100, marginTop: 4, boxShadow: 2, borderRadius: 3 }}>
              <CardContent>
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                  <CheckCircleIcon color="success" fontSize="large" />
                  <Typography variant="h5" style={{ color: theme.palette.success.main, fontWeight: 'bold' }}>
                    Dosya Başarıyla Yüklendi
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          ) : (
            <Card sx={{ minWidth: '100%', minHeight: 100, marginTop: 4, boxShadow: 2, borderRadius: 3 }}>
              <CardContent>
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                  <ErrorIcon color="error" fontSize="large" />
                  <Typography variant="h5" style={{ color: theme.palette.error.main, fontWeight: 'bold' }}>
                    Dosya Yüklenirken Bir Hata Oluştu
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          )
        )}

        {responseData?.data && (
          <Card sx={{ minWidth: 275, marginTop: 4, boxShadow: 2, borderRadius: 3 }}>
            <CardContent>
              <Typography variant="h3" component="div" color="primary" gutterBottom>
                İşlem Bilgileri
              </Typography>
              <Typography variant="h5" gutterBottom>
                Toplam Kayıt: {responseData.data?.totalRecord}
              </Typography>
              <Typography variant="h5" gutterBottom>
                Başarılı Kayıt: {responseData?.data?.successRecord}
              </Typography>
              <Typography variant="h5" gutterBottom>
                Başarısız Kayıt: {responseData?.data?.failRecord}
              </Typography>
              <Typography variant="h5" gutterBottom>
                Hata Mesajları:
              </Typography>
              {responseData && responseData.data.errorMessages ? (
                <div>
                  <Box display="flex" alignItems="center" gap={1}>
                    <ErrorIcon color="error" fontSize="large" />
                    <Typography variant="body1" style={{ color: theme.palette.error.main, fontWeight: 'bold' }}>
                      Toplam {responseData.data.errorMessages.length} hata bulundu:
                    </Typography>
                  </Box>
                  {responseData.data.errorMessages.map((error, index) => (
                    <Typography key={index} ml={6} variant="body2" color="error" style={{ fontSize: 'medium' }}>
                      {index + 1}. {error}
                    </Typography>
                  ))}
                </div>
              ) : (
                <Box display="flex" alignItems="center" gap={1}>
                  <CheckCircleIcon color="success" fontSize="large" />
                  <Typography variant="body1" style={{ color: theme.palette.success.main, fontWeight: 'bold' }}>
                    Herhangi Bir Hata Yok
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        )}


      </>
    );
  };

  const DownloadButton = () => {
    const fileURL = "/files/toplu-komisyon-ornek.xlsx";


    return (
      <a href={fileURL} download style={{ textDecoration: 'none' }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<GetAppIcon />}
          sx={{ height: '55px', width: '100%' }}
          text="KOMİSYON YÜKLEME DOSYASINI İNDİR"
        ></Button>
      </a>
    );
  };


  const handleBack = () => navigate("/commission-management/commission-codedefinition");

  return (
    <>

      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>
          <Stack spacing={4}>
            <Stack spacing={3}>
              <Stack
                spacing={3}
                width={isDesktop ? 800 : "auto"}
                direction="column"
              >
                <FormControl sx={{ flex: 1 }}>
                  <DownloadButton />
                </FormControl>
                <FormControl sx={{ flex: 1 }}>
                  <FileUpdload />
                </FormControl>

              </Stack>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          borderTop="1px solid #E6E9ED"
          py={2}
          pr={2}
          direction="row"
          justifyContent="flex-end"
        >
          {/* {!showCreate && (
  <Button
    onClick={handleSubmit(onSubmit)}
    variant="contained"
    text={commissionProfile && commissionProfile.id > 0 ? "Güncelle" : "Kaydet"}
  />
)} */}


          <Button onClick={handleBack} sx={{ mx: 2 }} text={"Iptal"} />
        </Stack>
      </Stack>
    </>
  );
};
